export default __webpack_public_path__ + "resources/icons/d341-1244.webp";